import Result from "@/core/common/Result";
import {
  IPodeVisualizarVisaoEstrategicaGateway,
  PodeVisualizarVisaoEstrategicaGatewayResponse
} from "../ports/PodeVisualizarVisaoEstrategicaGateway";
import { inject, injectable } from "inversify";
import { DITypes } from "@/core/@types/types";
import { type HttpClient } from "@/core/services/protocols/types";
import "reflect-metadata";
import { ContabilGatewayError } from "../../diagnostico/config/ContabilGatewayError";
import { IDefaultContabilResponse } from "@/services/contabil/types";

@injectable()
export class PodeVisualizarVisaoEstrategicaGatewayAdapter
  extends ContabilGatewayError
  implements IPodeVisualizarVisaoEstrategicaGateway
{
  @inject(DITypes.CONTABIL_HTTP_CLIENT)
  httpClient!: HttpClient;

  async podeVisualizar(
    ids?: string[]
  ): Promise<Result<PodeVisualizarVisaoEstrategicaGatewayResponse>> {
    try {
      const response = await this.httpClient.get<
        IDefaultContabilResponse<PodeVisualizarVisaoEstrategicaGatewayResponse>
      >({
        url: "v1/dashboard/lucro/pode-visualizar-visao-estrategica",
        queryParams: {
          empresaId: ids
        }
      });

      if (this.hasError(response)) {
        return Result.fail(
          "Não foi possível buscar as informações das empresas"
        );
      }

      return Result.ok(response.body?.result);
    } catch {
      return Result.fail(this.DEFAULT_ERROR);
    }
  }
}
